import { axios } from 'lib/axios';

export const registerWithPhoneAndPassword = (data) => {
  return axios.post('/members/register', data);
};
